export default __webpack_public_path__ + "images/6_habitat.jpg";